webpackJsonp([32],{

/***/ "Jvzq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/video-steps_c43a3400bfabc0a1e8e856bb6a35d0b5.html";

/***/ }),

/***/ "L1PK":
/***/ (function(module, exports, __webpack_require__) {

var VideoSteps = (function () {
    function VideoSteps() {
        this.videoPlayerSettings = {
            autoplay: true,
            isIcon: false
        };
    }
    return VideoSteps;
}());
angular.module('animatronApp.videoSteps', []).component('videoSteps', {
    bindings: {
        steps: '<',
        reverse: '<'
    },
    controller: VideoSteps,
    templateUrl: __webpack_require__("Jvzq")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/32-28dc41a6a889e793a2e2.min.js